<template>
	<header class="global-header-wrapper" :class="{ 'has-height': hasHeight }">
		<div class="inner" :class="{ white: bgWhite }">
			<div class="inner-box">
				<div class="left">
					<img class="logo" :src="bgWhite ? logoImg : logoWhiteImg" alt="高阳亿尚" @click="$router.push('/')" />
					<div class="menus" >
						<div class="menusRight">
							<div class="menusInner">
								<div class="menu-item activeEle" @click="menuItemClick('home','')"  :class="{act: routeName === 'home'&&route.params.a!='product'}" >
									首页
								</div>
								<div class="menu-item activeEle"  @click="menuItemClick('home','product')"  :class="{ act: routeName === 'home'&&route.params.a=='product' }"  >
									产品及服务
								</div>
								<div class="menu-item activeEle"  @click="menuItemClick('news')" :class="{ act: routeName === 'news' }">
									新闻资讯
								</div>
								<div class="menu-item activeEle" @click="menuItemClick('about')"  :class="{ act: routeName === 'about' }">
									关于我们
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>
		</div>
	</header>
	<header class="mobile-header-wrapper">
	  <div class="mobile-header-bar">
	    <img class="logo" src="../../assets/images/logo-black-red.png" alt="高阳亿尚" @click="$router.push('/')" />
	    <div class="right">
	      <div class="menu-btn" @click="menuVisible = true">
	        <menu-outlined />
	      </div>
	    </div>
	  </div>
	  <div class="mobile-header-popup" v-show="menuVisible">
	    <div class="mobile-header-bar">
	      <img class="logo" src="../../assets/images/logo-black-red.png" alt="高阳亿尚" @click="$router.push('/')" />
	      <div class="right">
	        <div class="menu-btn" @click="menuVisible = false">
	          <close-outlined />
	        </div>
	      </div>
	    </div>
	    <div class="menu-wrapper">
	      <div class="menu-list">
			  
			  
			  
	        <span
	          class="menu-item"
	         :class="{act: routeName === 'home'&&route.params.a!='product'}" 
	         @click="menuItemClick('home','')"
	        >
	          首页
	        </span>
	        <span
	          class="menu-item"
	          :class="{ act: routeName === 'home'&&route.params.a=='product' }"  
	           @click="menuItemClick('home','product')"
	        >
	          产品及服务
	        </span>
			<span
			  class="menu-item"
			  :class="{ act: routeName === 'news' }"
			 @click="menuItemClick('news')"
			>
			  新闻资讯
			</span>
	        <span
	          class="menu-item"
	          :class="{ act: routeName === 'about' }"
	           @click="menuItemClick('about')" 
	        >
	          关于我们
	        </span>
	      </div>
	    </div>
	  </div>
	</header>
</template>

<script setup>
import {
	ref,
	defineProps,
	computed,
	onMounted,
	onUnmounted
} from "vue";
import {
	useRoute,
	useRouter
} from "vue-router";
import logoImg from "../../assets/images/logo-black-red.png";
import logoWhiteImg from "../../assets/images/logo-white-red.png";
import {
	useStore
} from "vuex";
import {
	MenuOutlined,
	CloseOutlined
} from "@ant-design/icons-vue";
import {
	message
} from "ant-design-vue";
const props = defineProps({
	hasHeight: {
		type: Boolean,
		default: false,
	},
	isScroll: {
		type: Boolean,
		default: true,
	},
	initBgWhite:{
		type: Boolean,
		default: false,
	}

});
const emit = defineEmits(["changeAnchor",]);

const menuItemClick=function(name,anchor){
	if(name=='home'){
		console.log(route.name,'当前页面')
		router.push({ name: 'home', params: { a: anchor } })
		if(route.name=='home'){
			emit("changeAnchor",anchor);
		}else{
		}
	}else{
		router.push({ name: name })
	}
	
	menuVisible.value = false;
}

const route = useRoute();
const router = useRouter();
const store = useStore();
// console.log(store.state);
const routeName = computed(() => {
	return route.name;
});

const isLogined = computed(() => {
	return !!store.state.user?.token;
});

// const userName = computed(() => {
//   return (
//     store.state.user?.info?.userInfo?.userName ||
//     store.state.user?.info?.userInfo?.cellphone
//   );
// });

const bgWhite = ref(false);
let scrollTop = 0;
let mouseIsEntered = false;

function getScrollTop() {
	return (
		document.documentElement.scrollTop ||
		window.pageYOffset ||
		document.body.scrollTop
	);
}

function scroll() {
	scrollTop = getScrollTop();
	if (scrollTop >= 64) {
		bgWhite.value = true;
	} else {
		if (mouseIsEntered) {
			bgWhite.value = true;
		} else {
			bgWhite.value = false;
		}
	}
}

onMounted(() => {
	if (props.isScroll) {
		scrollTop = getScrollTop();
		document.addEventListener("scroll", scroll);
	}
	bgWhite.value=props.initBgWhite


});
onUnmounted(() => {
	if(props.isScroll){
		document.removeEventListener("scroll", scroll)
	}
});

function mouseenterFn() {
	// console.log("mouseenterFn");
	mouseIsEntered = true;
	bgWhite.value = true;
}

function mouseleaveFn() {
	mouseIsEntered = false;
	if (scrollTop < 64) bgWhite.value = false;
	else bgWhite.value = true;
}

const menuVisible = ref(false);
const mobileProductsDropDown = ref(false);

function toLink(url) {
	menuVisible.value = false;
	router.push(url);
}

// 登出
function logoutHandle() {
	store
		.dispatch("Logout")
		.then(() => {
			message.success("登出成功");
			console.log("登出成功");
			menuVisible.value = false;
		})
		.catch((err) => {
			console.log(err);
		});
}
</script>

<style lang="less" scoped>
.global-header-wrapper {
	height: 0;

	&.has-height {
		height: 64px;
	}
	
	.inner::after{
		content:'';
		display:block;
		position:absolute;
		width:200%;
		height: 1px;
		bottom:0;
		border-bottom:1px solid #BFBFBF;
		transform:scaleY(0.5);
		margin-left:-16px;
	}

	.inner {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		z-index: 99;

		.inner-box {
			margin: 0 auto;
			max-width: 1600px;
			min-width: 1200px;
			height: 64px;

			padding: 0 80px;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.left {
				flex: 1;
				display: flex;
				align-items: center;

				.logo {
					width: 133px;
					height: 34px;
					object-fit: contain;
					cursor: pointer;
				}
			}

		}

		.menus{
			.menu-item.act.isHeaderHoverRed {
				background: #EE0121 !important;
			}
		}

		.menus {
			flex: 1;
			text-align: right;

			.menusRight {
				display: inline-block;

				.menusInner {
					height: 64px;
					display: flex;

					.menu-item {
						margin-left: 24px;
						height: 64px;
						min-width: 120px;
						font-size: 16px;
						font-weight: 500;
						color: #ffffff;
						position: relative;
						display: flex;
						align-items: center;
						justify-content: center;
					}

					// .menu-item.act {
					// 	background: #EE0121;
					// }
					

					.menu-item.act {
						background: #0A1B61;
						opacity: 0.8;
						color: #FFFFFF  !important;
					}

				}
			}

		}





		.right {
			.my-center-btn {
				cursor: pointer;
				transition: all 0.3s;
				font-size: 14px;
				color: #fff;
			}

			.quit-btn {
				color: #fff;
				margin-left: 16px;
			}

			.btn {
				margin-left: 24px;
				width: 64px;
				height: 32px;
				border-radius: 20px;
				font-size: 14px;
				appearance: none;
				border: none;
				cursor: pointer;

				&.btn1 {
					background: transparent;
					border: 1px solid #fff;
					color: #fff;
				}

				&.btn2 {
					background: #2a60f3;
					color: #fff;
				}
			}
		}

		&.white {
			transition: all 0.2s;
			background-color: #fff;

			.menu-item {
				color: #333 !important;
			}

			.menu-item.act {
				background-color: #EE0121 !important;
				opacity:1 !important;
			}

			.menu-item .arrow {
				background-image: url(../../assets/icons/ic_down_black.png);
				transition: 0.2s;
			}

			.my-center-btn {
				color: #333;
			}

			.quit-btn {
				color: #333;
			}

			.right .btn1 {
				border: 1px solid #2a60f3;
				color: #2a60f3;
			}
		}
	}
}
// 移动端
.mobile-header-wrapper {
  display: none;
  height: 50px;
  
  .mobile-header-bar::after{
	  content:'';
	  display:block;
	  position:absolute;
	  width:100%;
	  height: 1px;
	  bottom:0;
	  border-bottom:1px solid #BFBFBF;
	  transform:scaleY(0.5);
	  margin-left:-16px;
	  
  }
  .mobile-header-bar {
    position: fixed;
    top: 0;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    padding-left: 16px;
    z-index: 99;
    .logo {
      // width: calc(100vw - 136px);
      max-width: 104px;
    }
    .right {
      flex-shrink: 0;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding-right: 8px;

      .btn {
        padding-left: 6px;
        padding-right: 6px;
        border-radius: 16px;
        font-size: 15px;
      }
      .menu-btn {
        width: 40px;
        height: 40px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
      }
    }
  }
  .mobile-header-popup {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    z-index: 100;
    .menu-wrapper {
      height: 100vh;
      padding-top: 50px;
      overflow-y: auto;
      overflow-x: hidden;
    }
    .menu-list {
      display: flex;
      flex-direction: column;
      padding: 0 16px;
    }
    .menu-item {
      height: 54px;
      border-bottom: 1px solid #eee;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #333;
      font-size: 16px;
      &.act {
        color: #2a60f3;
      }
    }
    .sub-menu {
      min-height: 54px;
      display: flex;
      flex-direction: column;
      border-bottom: 1px solid #eee;
      .menu-item {
        border-bottom: none;
      }
      .menu-item .arrow {
        margin-right: -16px;
        width: 54px;
        height: 54px;
        background: url(../../assets/icons/ic_down_black.png) no-repeat;
        background-size: 16px 16px;
        background-position: center center;
        &.open {
          transform: rotate(180deg);
        }
      }
    }
    .drop-down {
      padding-bottom: 10px;
      .title {
        height: 30px;
        line-height: 30px;
        font-size: 16px;
        color: #999;
        font-weight: 500;
      }
      .link-box {
        height: 50px;
        line-height: 50px;
        a {
          color: #333;
          font-size: 16px;
        }
      }
    }
    .logout-box {
      padding: 24px 16px;
    }
  }
}

@media screen and (max-width: 810px) {
  .global-header-wrapper {
    display: none;
  }
  .mobile-header-wrapper {
    display: block;
  }
}


</style>
